import React from "react";
import instituciones from "../instituciones.json";
import {
  ORDEN_ETAPAS,
  docenteTieneMultiEtapa,
  etapasDocenteOrdenadas,
} from "../utils/etapasReporte";
import "../ReporteDocente.css";

const DocenteCard = ({
  docente,
  colegio,
  etapasActivas,
  onToggleEtapa,
}) => {
  const iniciales = docente.profesor
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase();

  const dictaEtapas = etapasDocenteOrdenadas(docente.etapas);
  const multiEtapa = docenteTieneMultiEtapa(docente.etapas);
  const activasSet = etapasActivas instanceof Set ? etapasActivas : new Set();

  const colegioData = instituciones.find((i) => i.nombre === colegio);

  const handleEtapaClick = (etapa, enPlan) => {
    if (!multiEtapa || !enPlan || typeof onToggleEtapa !== "function") return;
    onToggleEtapa(etapa);
  };

  return (
    <div className="card docente-colegio">
      <div className="left-section">
        <div className="placeholder-foto">{iniciales}</div>
        <div className="info-docente">
          <h3>{docente.profesor}</h3>
          <div
            className={`barra-etapas ${multiEtapa ? "barra-etapas--toggle" : ""}`}
            role={multiEtapa ? "group" : undefined}
            aria-label={multiEtapa ? "Filtrar reporte por etapa" : undefined}
          >
            {ORDEN_ETAPAS.map((etapa) => {
              const enPlan = dictaEtapas.includes(etapa);
              const activa = activasSet.has(etapa);
              let pillClass = "etapa-pill";
              if (!enPlan) {
                pillClass += " etapa-pill--no-dicta";
              } else if (multiEtapa) {
                pillClass += activa
                  ? " etapa-pill--activa"
                  : " etapa-pill--toggle-off";
              } else {
                pillClass += " etapa-pill--activa";
              }

              const Tag = multiEtapa && enPlan ? "button" : "div";
              const extraProps =
                Tag === "button"
                  ? {
                      type: "button",
                      onClick: () => handleEtapaClick(etapa, enPlan),
                      "aria-pressed": activa,
                    }
                  : {};

              return (
                <Tag
                  key={etapa}
                  className={pillClass}
                  {...extraProps}
                >
                  {etapa}
                </Tag>
              );
            })}
          </div>
        </div>
      </div>

      <div className="right-section">
        {colegioData?.logo && (
          <img
            src={
              colegioData.logo.startsWith("http")
                ? colegioData.logo
                : `https://kuriosedu.s3.amazonaws.com/media/${colegioData.logo}`
            }
            alt={`Logo ${colegioData.nombre}`}
            className="logo"
          />
        )}
        <h3>{colegio}</h3>
      </div>
    </div>
  );
};

export default DocenteCard;
